import { RadialGradient } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';

import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

export function PopHeroGradientBg(): JSX.Element {
  const gen4Enabled = useOuraGen4Enabled();

  return (
    <div
      aria-hidden="true"
      className="absolute left-0 top-0 z-10 size-full"
      data-cy="pop_hero_gradient_bg"
    >
      <div
        className={cx(
          'absolute left-1/2 h-[40vh] w-[200vw] -translate-x-1/2 lg:hidden',
          {
            'bottom-[-4vh]': !gen4Enabled,
            'bottom-0 md:bottom-[-4vh]': gen4Enabled,
          },
        )}
        data-cy="pop_hero_bg_gradient_1_wrapper"
      >
        <RadialGradient
          hex="#897058"
          id="pop_hero_bg_gradient_1"
          opacity={gen4Enabled ? 0.8 : 1}
          position={[50, 50]}
          shape="ellipse"
          size={64}
        />
      </div>
      <div className="absolute left-[-40vw] top-[2vh] h-[30vh] w-[145vw] lg:hidden">
        <RadialGradient
          hex="#897058"
          id="pop_hero_bg_gradient_2"
          opacity={1}
          position={[50, 50]}
          shape="ellipse"
          size={64}
        />
      </div>
      <div className="absolute left-[-40vw] top-[-12vh] h-[40vh] w-[117vw] rotate-[37deg] lg:hidden">
        <RadialGradient
          hex="#EDD2B9"
          id="pop_hero_bg_gradient_3"
          opacity={1}
          position={[50, 50]}
          shape="ellipse"
          size={64}
        />
      </div>
      <div className="absolute -top-44 left-11 hidden h-[110vh] w-[50vw] rotate-[33.75deg] lg:block">
        <RadialGradient
          hex="#886E56"
          id="pop_hero_bg_gradient_4"
          opacity={1}
          position={[50, 50]}
          shape="ellipse"
          size={64}
        />
      </div>
    </div>
  );
}
